import {
  LOAD_INITIAL_DATA_REQUEST, LOAD_INITIAL_DATA_SUCCESS, LOAD_INITIAL_DATA_ERROR,
  SET_LANGUAGE, RESET_INITIAL_STATUS,
} from './types';

export const getters = {
  basicInfo: (state) => state.basicInfo,
};

export const mutations = {
  [SET_LANGUAGE]: (state, action) => {
    state.currentLanguage = action;
  },
  [LOAD_INITIAL_DATA_REQUEST]: (state) => {
    state.initialStatus = 'loading';
  },
  [LOAD_INITIAL_DATA_SUCCESS]: (state) => {
    state.initialStatus = 'success';
  },
  [LOAD_INITIAL_DATA_ERROR]: (state) => {
    state.initialStatus = 'error';
  },
  [RESET_INITIAL_STATUS]: (state) => {
    state.initialStatus = '';
  },
};

export const state = {
  currentLanguage: localStorage.getItem('locale') || '',
  initialStatus: '',
  basicInfo: {
    supportServiceEmail: 'support@repayapp.com',
  },
};
